import { render, staticRenderFns } from "./SurveyCreatorForm.vue?vue&type=template&id=f870c0f6"
import script from "./SurveyCreatorForm.vue?vue&type=script&lang=ts"
export * from "./SurveyCreatorForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports